import type { ChartPoint } from '../../../lib/metrics';
import { formatDateTime } from '../../../lib/time';
import { Table } from '../../atoms';

interface SeriesTableProps {
  points: ChartPoint[];
  formatValue: (value: number) => string;
  maxHeight: number;
}

/** The table twin of a chart: every bucket, newest first. */
export function SeriesTable({ points, formatValue, maxHeight }: SeriesTableProps) {
  return (
    <Table density="compact" maxHeight={maxHeight}>
      <thead>
        <tr>
          <th scope="col">Time</th>
          <th scope="col">Average</th>
          <th scope="col">Min</th>
          <th scope="col">Max</th>
          <th scope="col">Polls</th>
        </tr>
      </thead>
      <tbody>
        {[...points].reverse().map((p) => (
          <tr key={p.t}>
            <td>{formatDateTime(p.t)}</td>
            <td>{formatValue(p.avg)}</td>
            <td>{formatValue(p.min)}</td>
            <td>{formatValue(p.max)}</td>
            <td>{p.polls}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
